export type TFreshExtraProduct =
  | "SPRINKLES"
  | "NIBBLES_CHICKEN"
  | "NIBBLES_SALMON";

export type FreshExtraItemQuantity = Partial<Record<TFreshExtraProduct, number>>;

export type TUpdateExtraItemRequest = {
  subscriptionId: number;
  items: FreshExtraItemQuantity;
};

export type TUpdateExtraItemResponse = {
  subscriptionId: number;
  items: FreshExtraItemQuantity;
};

export const MAX_FRESH_EXTRAS_QUANTITIES = {
  SPRINKLES: 10,
  NIBBLES_CHICKEN: 4,
  NIBBLES_SALMON: 4,
} as const;
